/*----- Core -----*/
import Jimp from 'jimp'

/*----- Export -----*/
export default function imageProcessor(file) {
	return new Promise((resolve, reject) => {
		var fr = new FileReader()
		fr.onload = () => {
			Jimp.read(fr.result)
			.then( (image) => {
				let imageData 
				image.background(0xFFFFFFFF)
				image.contain(200, 200, Jimp.HORIZONTAL_ALIGN_CENTER | Jimp.VERTICAL_ALIGN_CENTER)
				image.getBase64(image.getMIME(), (err, data) => {
					imageData = data
				})
				resolve(imageData)
			})
			.catch(( error ) => {
				reject(error)
			})
		}
		fr.readAsDataURL(file)
	})
}